import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {
  ProfileSaleResponse,
  FilterProfileSalesRequest,
  FilterProfileSalesResponse,
  DeleteGroupProfileSalesRequest,
  GenerateGroupedSalesPdfRequest
} from "@numizmat/services-models/core";
import {Observable} from "rxjs";
import {environment} from "@numizmat/environments";

@Injectable({
  providedIn: 'root'
})
export class ProfileSaleApiService {
  private httpClient: HttpClient = inject(HttpClient);

  private profileSaleController: string = 'profileSale';

  public getAllProfileSales(): Observable<ProfileSaleResponse[]> {
    const endpoint = `${environment.apiCoreUrl}/${this.profileSaleController}/all`;
    return this.httpClient.get<ProfileSaleResponse[]>(endpoint);
  }

  public deleteProfileSale(saleHistoryId: string): Observable<number> {
    const endpoint = `${environment.apiCoreUrl}/${this.profileSaleController}/${saleHistoryId}`;
    return this.httpClient.delete<number>(endpoint);
  }

  public deleteGroupProfileSales(request: DeleteGroupProfileSalesRequest): Observable<number> {
    const endpoint = `${environment.apiCoreUrl}/${this.profileSaleController}/group/delete`;
    return this.httpClient.post<number>(endpoint, request);
  }

  public filterProfileSales(request: FilterProfileSalesRequest): Observable<FilterProfileSalesResponse> {
    const endpoint = `${environment.apiCoreUrl}/${this.profileSaleController}/filter`;
    return this.httpClient.post<FilterProfileSalesResponse>(endpoint, request);
  }

  public generateGroupedSalesPdf(request: GenerateGroupedSalesPdfRequest): Observable<Blob> {
    const endpoint = `${environment.apiCoreUrl}/${this.profileSaleController}/pdf/grouped-sales`;
    return this.httpClient.post(endpoint, request, {
      responseType: 'blob'
    });
  }
}
